import * as React from 'react';
import KDGlobal from 'src/components/Global';
import { Redirect } from 'react-router';
import { User } from 'src/api';
import { Subtract } from 'utility-types';

export type WithUser<Required extends boolean | undefined = false> = (Required extends true ? { user: User } : { user?: User })

export function withUser<P extends { user?: User }>(WrappedComponent: React.ComponentType<P>, required: boolean = false): React.ComponentClass<Subtract<P, WithUser>, { user?: User }> {
    return class extends React.Component<Subtract<P, WithUser>, { user?: User }> {

        constructor(props: P) {
            super(props);
            this.state = { user: KDGlobal.instance.getUser() }
        }

        componentDidMount() {
            KDGlobal.instance.on('user', this.didUpdateUser)
        }

        private didUpdateUser(user: User) {
            this.setState({ user: user })
        }

        componentWillUnmount() {
            KDGlobal.instance.removeEventListener('user', this.didUpdateUser)
        }

        public render() {
            if (required && !this.state.user) {
                return <Redirect to={'/login'} />
            }
            return (
                <WrappedComponent {...this.props as any} user={this.state.user} />
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/HOC/User.tsx